import React, { useState } from "react";
import Header from "../../Components/Header";
import { Link } from "react-router-dom";
import { sleeveszipperjacket } from "./Allitems";

function SleevesZipperJacket() {
  const [clothesdata, setclothesdata] = useState(sleeveszipperjacket);
  const [fillclothes, setfillclothes] = useState("");
  const filldata = (event) => {
    setfillclothes({ ...fillclothes, [event.target.name]: event.target.value });
  };
  const addcart = (key) => {
    const keysdata = [key, fillclothes];
    localStorage.setItem("Data", JSON.stringify(keysdata));
  };

  return (
    <div>
      <Header />
      {clothesdata.map((id) => {
        return (
          <>
            <main className="main">
              <nav
                aria-label="breadcrumb"
                className="breadcrumb-nav border-0 mb-0"
              >
                <div className="container d-flex align-items-center">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Products</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Sticky Info
                    </li>
                  </ol>
                  <nav className="product-pager ml-auto" aria-label="Product">
                    <a
                      className="product-pager-link product-pager-prev"
                      href="#"
                      aria-label="Previous"
                      tabIndex={-1}
                    >
                      <i className="icon-angle-left" />
                      <span>Prev</span>
                    </a>
                    <a
                      className="product-pager-link product-pager-next"
                      href="#"
                      aria-label="Next"
                      tabIndex={-1}
                    >
                      <span>Next</span>
                      <i className="icon-angle-right" />
                    </a>
                  </nav>
                  {/* End .pager-nav */}
                </div>
                {/* End .container */}
              </nav>
              {/* End .breadcrumb-nav */}
              <div className="page-content">
                <div className="container">
                  <div className="product-details-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="product-gallery product-gallery-separated">
                          <span className="product-label label-sale">Sale</span>
                          <figure className="product-separated-item">
                            <img
                              src={clothesdata[0].img1}
                              data-zoom-image="assets/images/products/single/sticky/1-big.jpg"
                              alt="product image"
                            />
                            <a
                              href="#"
                              id="btn-separated-gallery"
                              className="btn-product-gallery"
                            >
                              <i className="icon-arrows" />
                            </a>
                          </figure>
                          <figure className="product-separated-item">
                            <img
                              src={clothesdata[0].img2}
                              data-zoom-image="assets/images/products/single/sticky/2-big.jpg"
                              alt="product image"
                            />
                          </figure>
                          <figure className="product-separated-item">
                            <img
                              src={clothesdata[0].img3}
                              data-zoom-image="assets/images/products/single/sticky/3-big.jpg"
                              alt="product image"
                            />
                          </figure>
                          <figure className="product-separated-item">
                            <img
                              src={clothesdata[0].img4}
                              data-zoom-image="assets/images/products/single/sticky/4-big.jpg"
                              alt="product image"
                            />
                          </figure>
                        </div>
                        {/* End .product-gallery */}
                      </div>
                      {/* End .col-md-6 */}
                      <div className="col-md-6">
                        <div className="product-details sticky-content">
                          <h1 className="product-title">
                            {clothesdata[0].Product}
                          </h1>
                          {/* End .product-title */}
                          <div className="ratings-container">
                            <div className="ratings">
                              <div
                                className="ratings-val"
                                style={{ width: "80%" }}
                              />
                              {/* End .ratings-val */}
                            </div>
                            {/* End .ratings */}
                            <a
                              className="ratings-text"
                              href="#product-accordion"
                              id="review-link"
                            >
                              ( 2 Reviews )
                            </a>
                          </div>
                          {/* End .rating-container */}
                          <div className="product-price">
                            <span className="new-price">
                              {" "}
                              {clothesdata[0].Price}
                            </span>
                            <span className="old-price">
                              {clothesdata[0].Oldprice}
                            </span>
                          </div>
                          {/* End .product-price */}
                          <div className="product-content">
                            <p>{/* Sub Lines */}</p>
                          </div>
                          {/* End .product-content */}
                          <div
                            className="product-countdown"
                            data-until="2019, 10, 29"
                          />
                          {/* End .product-countdown */}
                          <div className="details-filter-row details-row-size">
                            <label htmlFor="size">Size:</label>
                            <div className="select-custom">
                              <select
                                name="size"
                                id="size"
                                className="form-control"
                                onChange={filldata}
                              >
                                <option value="#" selected="selected">
                                  Select a size
                                </option>
                                <option name="4-5">4 Years 5 Years</option>
                                <option name="5-6">5 Years 6 Years</option>
                                <option name="6-7">6 Years 7 Years</option>
                                <option name="7-8">7 Years 8 Years</option>
                                <option name="8-9">8 Years 9 Years</option>
                                <option name="9-10">9 Years 10 Years</option>
                                <option name="10-11">10 Years 11 Years</option>
                                <option name="11-12">11 Years 12 Years</option>
                                <option name="13-14">13 Years 14 Years</option>
                                <option name="14-14">14 Years 15 Years</option>
                                <option name="15-16">15 Years 16 Years</option>
                                {/* <option name="6uk">6 UK</option>
                                <option name="7uk">7 UK</option>
                                <option name="8uk">8 UK</option> */}
                              </select>
                            </div>
                            {/* End .select-custom */}
                            <a href="#" className="size-guide">
                              <i className="icon-th-list" />
                              size guide
                            </a>
                          </div>
                          {/* End .details-filter-row */}
                          <div className="details-filter-row details-row-size">
                            <label htmlFor="qty">Qty:</label>
                            <div className="product-details-quantity">
                              <input
                                onChange={filldata}
                                name="qty"
                                type="number"
                                id="qty"
                                className="form-control"
                                defaultValue={1}
                                min={1}
                                max={10}
                                step={1}
                                data-decimals={0}
                                required
                              />
                            </div>
                            {/* End .product-details-quantity */}
                          </div>
                          {/* End .details-filter-row */}
                          <div
                            className="product-details-action"
                            onClick={() => addcart(id)}
                          >
                            <a href="#" className="btn-product btn-cart">
                              <span>add to cart</span>
                            </a>
                            <div className="details-action-wrapper">
                              <a
                                href="#"
                                className="btn-product btn-wishlist"
                                title="Wishlist"
                              >
                                <span>Add to Wishlist</span>
                              </a>
                              <a
                                href="#"
                                className="btn-product btn-compare"
                                title="Compare"
                              >
                                <span>Add to Compare</span>
                              </a>
                            </div>
                            {/* End .details-action-wrapper */}
                          </div>
                          {/* End .product-details-action */}
                          <div className="product-details-footer">
                            <div className="product-cat">
                              <span>Category:</span>
                              <Link to="/women">Women</Link>,
                              <Link to="/womenclothes">Dresses</Link>,
                              {/* <a href="#">Yellow</a> */}
                            </div>
                            {/* End .product-cat */}
                            <div className="social-icons social-icons-sm">
                              <span className="social-label">Share:</span>
                              <a
                                href="#"
                                className="social-icon"
                                title="Facebook"
                                target="_blank"
                              >
                                <i className="icon-facebook-f" />
                              </a>
                              <a
                                href="#"
                                className="social-icon"
                                title="Twitter"
                                target="_blank"
                              >
                                <i className="icon-twitter" />
                              </a>
                              <a
                                href="#"
                                className="social-icon"
                                title="Instagram"
                                target="_blank"
                              >
                                <i className="icon-instagram" />
                              </a>
                              <a
                                href="#"
                                className="social-icon"
                                title="Pinterest"
                                target="_blank"
                              >
                                <i className="icon-pinterest" />
                              </a>
                            </div>
                          </div>
                          {/* End .product-details-footer */}
                          <div
                            className="accordion accordion-plus product-details-accordion"
                            id="product-accordion"
                          >
                            <div className="card card-box card-sm">
                              <div
                                className="card-header"
                                id="product-desc-heading"
                              >
                                <h2 className="card-title">
                                  <a
                                    className="collapsed"
                                    role="button"
                                    data-toggle="collapse"
                                    href="#product-accordion-desc"
                                    aria-expanded="false"
                                    aria-controls="product-accordion-desc"
                                  >
                                    Description
                                  </a>
                                </h2>
                              </div>
                              {/* End .card-header */}
                              <div
                                id="product-accordion-desc"
                                className="collapse"
                                aria-labelledby="product-desc-heading"
                                data-parent="#product-accordion"
                              >
                                <div className="card-body">
                                  <div className="product-desc-content">
                                    <p>{/* Description */}</p>
                                    <ul>
                                      <li>Care Instructions: Machine Wash</li>
                                      <li>Fit Type: Regular</li>
                                      <li>
                                        Fit Type: Regular Fit; Size Details : S
                                        - 34 Chest/31 Waist , M - 36 Chest/33
                                        Waist, L - 38 Chest/35 Waist , Xl - 40
                                        Chest/37 Waist
                                      </li>
                                      <li>
                                        Product Length Varies From 18 To 19
                                        Inches Based On Size Available From S To
                                        Xl
                                      </li>
                                      <li>
                                        Occasion Type : Western Wear; Fabric :
                                        Denim Fabric
                                      </li>
                                      <li>Sleeve Type: Long Sleeve</li>
                                    </ul>
                                    <p>{/* One More line */}</p>
                                  </div>
                                  {/* End .product-desc-content */}
                                </div>
                                {/* End .card-body */}
                              </div>
                              {/* End .collapse */}
                            </div>
                            {/* End .card */}
                            {/* <div className="card card-box card-sm">
                              <div
                                className="card-header"
                                id="product-info-heading"
                              >
                                <h2 className="card-title">
                                  <a
                                    role="button"
                                    data-toggle="collapse"
                                    href="#product-accordion-info"
                                    aria-expanded="true"
                                    aria-controls="product-accordion-info"
                                  >
                                    Additional Information
                                  </a>
                                </h2>
                              </div>
                              End .card-header
                              <div
                                id="product-accordion-info"
                                className="collapse show"
                                aria-labelledby="product-info-heading"
                                data-parent="#product-accordion"
                              >
                                <div className="card-body">
                                  <div className="product-desc-content">
                                    <p>
                                      Lorem ipsum dolor sit amet, consectetuer
                                      adipiscing elit. Donec odio. Quisque
                                      volutpat mattis eros. Nullam malesuada
                                      erat ut turpis. Suspendisse urna viverra
                                      non, semper suscipit, posuere a, pede.
                                      Donec nec justo eget felis facilisis
                                      fermentum. Aliquam porttitor mauris sit
                                      amet orci.{" "}
                                    </p>
                                    <h3>Fabric &amp; care</h3>
                                    <ul>
                                      <li>100% Polyester</li>
                                      <li>Do not iron</li>
                                      <li>Do not wash</li>
                                      <li>Do not bleach</li>
                                      <li>Do not tumble dry</li>
                                      <li>Professional dry clean only</li>
                                    </ul>
                                    <h3>Size</h3>
                                    <p>S, M, L, XL</p>
                                  </div>
                                  End .product-desc-content
                                </div>
                                End .card-body
                              </div>
                              End .collapse
                            </div> */}

                            {/* End .card */}
                            <div className="card card-box card-sm">
                              <div
                                className="card-header"
                                id="product-shipping-heading"
                              >
                                <h2 className="card-title">
                                  <a
                                    className="collapsed"
                                    role="button"
                                    data-toggle="collapse"
                                    href="#product-accordion-shipping"
                                    aria-expanded="false"
                                    aria-controls="product-accordion-shipping"
                                  >
                                    Shipping &amp; Returns
                                  </a>
                                </h2>
                              </div>
                              {/* End .card-header */}
                              <div
                                id="product-accordion-shipping"
                                className="collapse"
                                aria-labelledby="product-shipping-heading"
                                data-parent="#product-accordion"
                              >
                                <div className="card-body">
                                  <div className="product-desc-content">
                                    <p>
                                      We deliver to over 100 countries around
                                      the world. For full details of the
                                      delivery options we offer, please view our{" "}
                                      <a href="#">Delivery information</a>
                                      <br />
                                      We hope you’ll love every purchase, but if
                                      you ever need to return an item you can do
                                      so within a month of receipt. For full
                                      details of how to make a return, please
                                      view our{" "}
                                      <a href="#">Returns information</a>
                                    </p>
                                  </div>
                                  {/* End .product-desc-content */}
                                </div>
                                {/* End .card-body */}
                              </div>
                              {/* End .collapse */}
                            </div>
                            {/* End .card */}
                            <div className="card card-box card-sm">
                              <div
                                className="card-header"
                                id="product-review-heading"
                              >
                                <h2 className="card-title">
                                  <a
                                    className="collapsed"
                                    role="button"
                                    data-toggle="collapse"
                                    href="#product-accordion-review"
                                    aria-expanded="false"
                                    aria-controls="product-accordion-review"
                                  >
                                    Reviews (2)
                                  </a>
                                </h2>
                              </div>
                              {/* End .card-header */}
                              <div
                                id="product-accordion-review"
                                className="collapse"
                                aria-labelledby="product-review-heading"
                                data-parent="#product-accordion"
                              >
                                <div className="card-body">
                                  <div className="reviews">
                                    <div className="review">
                                      <div className="row no-gutters">
                                        <div className="col-auto">
                                          <h4>
                                            <a href="#">Pooja Sharma</a>
                                          </h4>
                                          <div className="ratings-container">
                                            <div className="ratings">
                                              <div
                                                className="ratings-val"
                                                style={{ width: "80%" }}
                                              />
                                              {/* End .ratings-val */}
                                            </div>
                                            {/* End .ratings */}
                                          </div>
                                          {/* End .rating-container */}
                                          <span className="review-date">
                                            6 days ago
                                          </span>
                                        </div>
                                        {/* End .col */}
                                        <div className="col">
                                          <h4>Good, perfect size</h4>
                                          <div className="review-content">
                                            <p>
                                              This product is pretty good for
                                              the value of money and quality of
                                              the cloth is good ... I will
                                              suggest to buy the perfect size u
                                              need as I was in doubt and i
                                              ordered one size bigger than mine
                                              , and it doesn't fits me well , so
                                              please order the exact size u need
                                              ... Overall it's amazing
                                            </p>
                                          </div>
                                          {/* End .review-content */}
                                          <div className="review-action">
                                            <a href="#">
                                              <i className="icon-thumbs-up" />
                                              Helpful (2)
                                            </a>
                                            <a href="#">
                                              <i className="icon-thumbs-down" />
                                              Unhelpful (0)
                                            </a>
                                          </div>
                                          {/* End .review-action */}
                                        </div>
                                        {/* End .col-auto */}
                                      </div>
                                      {/* End .row */}
                                    </div>
                                    {/* End .review */}
                                    <div className="review">
                                      <div className="row no-gutters">
                                        <div className="col-auto">
                                          <h4>
                                            <a href="#">Ravi Goyal</a>
                                          </h4>
                                          <div className="ratings-container">
                                            <div className="ratings">
                                              <div
                                                className="ratings-val"
                                                style={{ width: "100%" }}
                                              />
                                              {/* End .ratings-val */}
                                            </div>
                                            {/* End .ratings */}
                                          </div>
                                          {/* End .rating-container */}
                                          <span className="review-date">
                                            5 days ago
                                          </span>
                                        </div>
                                        {/* End .col */}
                                        <div className="col">
                                          <h4>Very good</h4>
                                          <div className="review-content">
                                            <p>
                                              I like the product very very very
                                              much . I m very happy 😁 . Fit as
                                              axpected . And Product as shown in
                                              the photo: I got better than
                                              that..
                                            </p>
                                          </div>
                                          {/* End .review-content */}
                                          <div className="review-action">
                                            <a href="#">
                                              <i className="icon-thumbs-up" />
                                              Helpful (0)
                                            </a>
                                            <a href="#">
                                              <i className="icon-thumbs-down" />
                                              Unhelpful (0)
                                            </a>
                                          </div>
                                          {/* End .review-action */}
                                        </div>
                                        {/* End .col-auto */}
                                      </div>
                                      {/* End .row */}
                                    </div>
                                    {/* End .review */}
                                  </div>
                                  {/* End .reviews */}
                                </div>
                                {/* End .card-body */}
                              </div>
                              {/* End .collapse */}
                            </div>
                            {/* End .card */}
                          </div>
                          {/* End .accordion */}
                        </div>
                        {/* End .product-details */}
                      </div>
                      {/* End .col-md-6 */}
                    </div>
                    {/* End .row */}
                  </div>
                  {/* End .product-details-top */}
                  <hr className="mt-3 mb-5" />
                  <h2 className="title text-center mb-4">You May Also Like</h2>
                  {/* End .title text-center */}
                  <div
                    className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow"
                    data-toggle="owl"
                    data-owl-options='{
              "nav": false, 
              "dots": true,
              "margin": 20,
              "loop": false,
              "responsive": {
                  "0": {
                      "items":1
                  },
                  "480": {
                      "items":2
                  },
                  "768": {
                      "items":3
                  },
                  "992": {
                      "items":4
                  },
                  "1200": {
                      "items":4,
                      "nav": true,
                      "dots": false
                  }
              }
          }'
                  >
                    <div className="product product-7">
                      <figure className="product-media">
                        <span className="product-label label-new">New</span>
                        <a href="product.html">
                          <img
                            src="assets/images/products/product-4.jpg"
                            alt="Product image"
                            className="product-image"
                          />
                        </a>
                        <div className="product-action-vertical">
                          <a
                            href="#"
                            className="btn-product-icon btn-wishlist btn-expandable"
                          >
                            <span>add to wishlist</span>
                          </a>
                          <a
                            href="popup/quickView.html"
                            className="btn-product-icon btn-quickview"
                            title="Quick view"
                          >
                            <span>Quick view</span>
                          </a>
                          <a
                            href="#"
                            className="btn-product-icon btn-compare"
                            title="Compare"
                          >
                            <span>Compare</span>
                          </a>
                        </div>
                        {/* End .product-action-vertical */}
                        <div className="product-action">
                          <a href="#" className="btn-product btn-cart">
                            <span>add to cart</span>
                          </a>
                        </div>
                        {/* End .product-action */}
                      </figure>
                      {/* End .product-media */}
                      <div className="product-body">
                        <div className="product-cat">
                          <a href="#">Women</a>
                        </div>
                        {/* End .product-cat */}
                        <h3 className="product-title">
                          <a href="product.html">
                            Brown paperbag waist <br />
                            pencil skirt
                          </a>
                        </h3>
                        {/* End .product-title */}
                        <div className="product-price">$60.00</div>
                        {/* End .product-price */}
                        <div className="ratings-container">
                          <div className="ratings">
                            <div
                              className="ratings-val"
                              style={{ width: "20%" }}
                            />
                            {/* End .ratings-val */}
                          </div>
                          {/* End .ratings */}
                          <span className="ratings-text">( 2 Reviews )</span>
                        </div>
                        {/* End .rating-container */}
                        <div className="product-nav product-nav-dots">
                          <a
                            href="#"
                            className="active"
                            style={{ background: "#cc9966" }}
                          >
                            <span className="sr-only">Color name</span>
                          </a>
                          <a href="#" style={{ background: "#7fc5ed" }}>
                            <span className="sr-only">Color name</span>
                          </a>
                          <a href="#" style={{ background: "#e8c97a" }}>
                            <span className="sr-only">Color name</span>
                          </a>
                        </div>
                        {/* End .product-nav */}
                      </div>
                      {/* End .product-body */}
                    </div>
                    {/* End .product */}
                    <div className="product product-7">
                      <figure className="product-media">
                        <span className="product-label label-out">
                          Out of Stock
                        </span>
                        <a href="product.html">
                          <img
                            src="assets/images/products/product-6.jpg"
                            alt="Product image"
                            className="product-image"
                          />
                        </a>
                        <div className="product-action-vertical">
                          <a
                            href="#"
                            className="btn-product-icon btn-wishlist btn-expandable"
                          >
                            <span>add to wishlist</span>
                          </a>
                          <a
                            href="popup/quickView.html"
                            className="btn-product-icon btn-quickview"
                            title="Quick view"
                          >
                            <span>Quick view</span>
                          </a>
                          <a
                            href="#"
                            className="btn-product-icon btn-compare"
                            title="Compare"
                          >
                            <span>Compare</span>
                          </a>
                        </div>
                        {/* End .product-action-vertical */}
                        <div className="product-action">
                          <a href="#" className="btn-product btn-cart">
                            <span>add to cart</span>
                          </a>
                        </div>
                        {/* End .product-action */}
                      </figure>
                      {/* End .product-media */}
                      <div className="product-body">
                        <div className="product-cat">
                          <a href="#">Jackets</a>
                        </div>
                        {/* End .product-cat */}
                        <h3 className="product-title">
                          <a href="product.html">
                            Khaki utility boiler jumpsuit
                          </a>
                        </h3>
                        {/* End .product-title */}
                        <div className="product-price">
                          <span className="out-price">$120.00</span>
                        </div>
                        {/* End .product-price */}
                        <div className="ratings-container">
                          <div className="ratings">
                            <div
                              className="ratings-val"
                              style={{ width: "80%" }}
                            />
                            {/* End .ratings-val */}
                          </div>
                          {/* End .ratings */}
                          <span className="ratings-text">( 6 Reviews )</span>
                        </div>
                        {/* End .rating-container */}
                      </div>
                      {/* End .product-body */}
                    </div>
                    {/* End .product */}
                    <div className="product product-7">
                      <figure className="product-media">
                        <span className="product-label label-top">Top</span>
                        <a href="product.html">
                          <img
                            src="assets/images/products/product-11.jpg"
                            alt="Product image"
                            className="product-image"
                          />
                        </a>
                        <div className="product-action-vertical">
                          <a
                            href="#"
                            className="btn-product-icon btn-wishlist btn-expandable"
                          >
                            <span>add to wishlist</span>
                          </a>
                          <a
                            href="popup/quickView.html"
                            className="btn-product-icon btn-quickview"
                            title="Quick view"
                          >
                            <span>Quick view</span>
                          </a>
                          <a
                            href="#"
                            className="btn-product-icon btn-compare"
                            title="Compare"
                          >
                            <span>Compare</span>
                          </a>
                        </div>
                        {/* End .product-action-vertical */}
                        <div className="product-action">
                          <a href="#" className="btn-product btn-cart">
                            <span>add to cart</span>
                          </a>
                        </div>
                        {/* End .product-action */}
                      </figure>
                      {/* End .product-media */}
                      <div className="product-body">
                        <div className="product-cat">
                          <a href="#">Shoes</a>
                        </div>
                        {/* End .product-cat */}
                        <h3 className="product-title">
                          <a href="product.html">
                            Light brown studded Wide fit wedges
                          </a>
                        </h3>
                        {/* End .product-title */}
                        <div className="product-price">$110.00</div>
                        {/* End .product-price */}
                        <div className="ratings-container">
                          <div className="ratings">
                            <div
                              className="ratings-val"
                              style={{ width: "80%" }}
                            />
                            {/* End .ratings-val */}
                          </div>
                          {/* End .ratings */}
                          <span className="ratings-text">( 1 Reviews )</span>
                        </div>
                        {/* End .rating-container */}
                        <div className="product-nav product-nav-dots">
                          <a
                            href="#"
                            className="active"
                            style={{ background: "#8b513d" }}
                          >
                            <span className="sr-only">Color name</span>
                          </a>
                          <a href="#" style={{ background: "#333333" }}>
                            <span className="sr-only">Color name</span>
                          </a>
                          <a href="#" style={{ background: "#d2b99a" }}>
                            <span className="sr-only">Color name</span>
                          </a>
                        </div>
                        {/* End .product-nav */}
                      </div>
                      {/* End .product-body */}
                    </div>
                    {/* End .product */}
                    <div className="product product-7">
                      <figure className="product-media">
                        <a href="product.html">
                          <img
                            src="assets/images/products/product-10.jpg"
                            alt="Product image"
                            className="product-image"
                          />
                        </a>
                        <div className="product-action-vertical">
                          <a
                            href="#"
                            className="btn-product-icon btn-wishlist btn-expandable"
                          >
                            <span>add to wishlist</span>
                          </a>
                          <a
                            href="popup/quickView.html"
                            className="btn-product-icon btn-quickview"
                            title="Quick view"
                          >
                            <span>Quick view</span>
                          </a>
                          <a
                            href="#"
                            className="btn-product-icon btn-compare"
                            title="Compare"
                          >
                            <span>Compare</span>
                          </a>
                        </div>
                        {/* End .product-action-vertical */}
                        <div className="product-action">
                          <a href="#" className="btn-product btn-cart">
                            <span>add to cart</span>
                          </a>
                        </div>
                        {/* End .product-action */}
                      </figure>
                      {/* End .product-media */}
                      <div className="product-body">
                        <div className="product-cat">
                          <a href="#">Jumpers</a>
                        </div>
                        {/* End .product-cat */}
                        <h3 className="product-title">
                          <a href="product.html">Yellow button front tea top</a>
                        </h3>
                        {/* End .product-title */}
                        <div className="product-price">$56.00</div>
                        {/* End .product-price */}
                        <div className="ratings-container">
                          <div className="ratings">
                            <div
                              className="ratings-val"
                              style={{ width: "0%" }}
                            />
                            {/* End .ratings-val */}
                          </div>
                          {/* End .ratings */}
                          <span className="ratings-text">( 0 Reviews )</span>
                        </div>
                        {/* End .rating-container */}
                      </div>
                      {/* End .product-body */}
                    </div>
                    {/* End .product */}
                    <div className="product product-7">
                      <figure className="product-media">
                        <a href="product.html">
                          <img
                            src="assets/images/products/product-7.jpg"
                            alt="Product image"
                            className="product-image"
                          />
                        </a>
                        <div className="product-action-vertical">
                          <a
                            href="#"
                            className="btn-product-icon btn-wishlist btn-expandable"
                          >
                            <span>add to wishlist</span>
                          </a>
                          <a
                            href="popup/quickView.html"
                            className="btn-product-icon btn-quickview"
                            title="Quick view"
                          >
                            <span>Quick view</span>
                          </a>
                          <a
                            href="#"
                            className="btn-product-icon btn-compare"
                            title="Compare"
                          >
                            <span>Compare</span>
                          </a>
                        </div>
                        {/* End .product-action-vertical */}
                        <div className="product-action">
                          <a href="#" className="btn-product btn-cart">
                            <span>add to cart</span>
                          </a>
                        </div>
                        {/* End .product-action */}
                      </figure>
                      {/* End .product-media */}
                      <div className="product-body">
                        <div className="product-cat">
                          <a href="#">Jeans</a>
                        </div>
                        {/* End .product-cat */}
                        <h3 className="product-title">
                          <a href="product.html">
                            Blue utility pinafore denim dress
                          </a>
                        </h3>
                        {/* End .product-title */}
                        <div className="product-price">$76.00</div>
                        {/* End .product-price */}
                        <div className="ratings-container">
                          <div className="ratings">
                            <div
                              className="ratings-val"
                              style={{ width: "20%" }}
                            />
                            {/* End .ratings-val */}
                          </div>
                          {/* End .ratings */}
                          <span className="ratings-text">( 2 Reviews )</span>
                        </div>
                        {/* End .rating-container */}
                      </div>
                      {/* End .product-body */}
                    </div>
                    {/* End .product */}
                  </div>
                  {/* End .owl-carosel */}
                </div>
                {/* End .container */}
              </div>
              {/* End .page-content */}
            </main>
          </>
        );
      })}
    </div>
  );
}

export default SleevesZipperJacket;
